import styled from '@emotion/styled';
import { rgba } from 'polished';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const EntryButtonArea = styled.div((props: { isEntered: boolean }) =>
  mq({
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: rgba('#000000', 0.8),
    padding: `${defaultTheme.spacing.l} 0`,
    '& > button': {
      opacity: props.isEntered ? '0.5' : '1',
    },
  }),
);
